import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  infoIcon: {
    cursor: 'initial',
    marginRight: 6,
    width: 20,
    height: 20,
    minWidth: 20,
  },
  disclaimer: {
    alignItems: 'center',
    color: '#54565B',
    display: 'flex',
    fontSize: 14,
    left: 155,
    lineHeight: '16px',
    position: 'absolute',
    top: 2,
    width: 510,
    [theme.breakpoints.down('lg')]: {
      left: 148,
      top: 8,
    },
  },
  warningIcon: {
    height: 20,
    width: 20,
    '& path': {
      stroke: theme.palette.primary2,
    },
  },
}));
